'use strict'

import {createScapiFetch} from './utils'

class SitemapMgr {
    constructor(config) {
        this.config = config
        this.fetch = createScapiFetch(config)
    }

    /**
     * Asynchronously retrieves the HTML sitemap for a specified site.
     *
     * @param {string} siteId - The unique identifier of the site for which the sitemap is to be retrieved.
     * @param {string} accessToken - The access token required for authentication to access the API.
     * @returns {Promise<Object>} A promise that resolves to the sitemap response object. If an error occurs, an empty object is returned.
     *
     * @throws Will return an empty object if the API request fails.
     */
    async sitemap(siteId, accessToken) {
        let endpoint = 'html-sitemap'
        let method = 'GET'
        let methodName = 'sitemap'
        let requestParams = {
            body: null,
            apiPath: 'sitemap',
            accessToken: accessToken,
            isCached: false,
            siteID: siteId
        }
        let apiVersion = 'v1'
        let siteMapResponse
        let urlParam = {
            querystring: {}
        }

        try {
            siteMapResponse = await this.fetch(
                endpoint,
                method,
                [urlParam],
                methodName,
                requestParams,
                apiVersion
            )

            return siteMapResponse || {}
        } catch (error) {
            return {}
        }
    }
}

export default SitemapMgr
